const stringMayBeJSON = (str: string): boolean => !str ? false : (str.startsWith('{') && str.endsWith('}')) || (str.startsWith('[') && str.endsWith(']'))

export const formatAddress = (rawAddress: string | undefined): string => {
  if (!rawAddress) return ''
  if (!stringMayBeJSON(rawAddress)) return rawAddress
  const parsed = JSON.parse(rawAddress)
  const { address1, address2, lastLine } = Array.isArray(parsed) ? parsed[0] : parsed
  return [address1, address2, lastLine].filter((v) => v).join(' ')
}